import WhActivityIndex from "./WhActivityIndex.vue";
import WhActivityAdd from "./WhActivityAdd.vue";
import WhActivityDetail from "./WhActivityDetail.vue";
import WhActivityEdit from "./WhActivityEdit.vue";

let routes= [
    {
        path: '',
        meta: {
          title: "List Warehouse Activity",
        },
        name: "WhActivityIndex",
        component: WhActivityIndex
    },
    {
        path: 'create',
        meta: {
          title: "Create Warehouse Activity",
        },
        name: "WhActivityAdd",
        component: WhActivityAdd
    },
     
    {
        path: 'detail/:id',
        meta: {
          title: "Detail Warehouse Activity",
        },
        name: "WhActivityDetail",
        component: WhActivityDetail
    },
     
    {
        path: 'edit/:id',
        meta: {
          title: "Edit Warehouse Activity",
        },
        name: "WhActivityEdit",
        component: WhActivityEdit
    },
  
    
]

export default routes
  